// Compteurs légers pour les onglets du détail dossier (head:true → pas de rows).
import { useQuery } from '@tanstack/react-query';
import { supabase } from '../../lib/supabaseClient';
import { LIVE } from '../../lib/queryPresets';

async function countRows(
  table: 'dossier_contacts' | 'dossier_files' | 'tasks',
  dossierId: string,
  extra?: (q: any) => any,
): Promise<number> {
  let query = supabase.from(table).select('*', { count: 'exact', head: true }).eq('dossier_id', dossierId);
  if (extra) query = extra(query);
  const { count, error } = await query;
  if (error) return 0; // best-effort : un compteur absent ne casse pas la page
  return count ?? 0;
}

export function useDossierTabCounts(dossierId: string | undefined) {
  return useQuery({
    ...LIVE, // compteurs affichés en permanence sur le dossier ouvert, pas de Realtime dessus
    queryKey: ['dossier-tab-counts', dossierId],
    enabled: !!dossierId,
    queryFn: async () => {
      const today = new Date().toISOString().slice(0, 10);
      const [parties, documents, taches, tachesRetard] = await Promise.all([
        countRows('dossier_contacts', dossierId!),
        countRows('dossier_files', dossierId!),
        countRows('tasks', dossierId!, (q) => q.eq('is_completed', false).eq('is_deleted', false)),
        countRows('tasks', dossierId!, (q) =>
          q.eq('is_completed', false).eq('is_deleted', false).lt('due_date', today),
        ),
      ]);
      return { parties, documents, taches, tachesRetard };
    },
  });
}
